import Vue from 'vue';
import AdminDataCollectionStats from '@/components/admin/AdminDataCollectionStats.vue';
import AdminDataCollectionView from '@/components/admin/AdminDataCollectionView.vue';
// import AdminOfficeDetails from '@/components/admin/AdminOfficeDetails.vue';
import OfficeTreeView from '@/components/admin/OfficeTreeView.vue';
import AdminOfficeDetailsView from '@/components/admin/AdminOfficeDetailsView.vue';
import Reports from '@/components/admin/Reports.vue';
import ReportMain from '@/components/admin/ReportMain.vue';
import ReportDetail from '@/components/admin/ReportDetail.vue';
import Report100M from '@/components/admin/Report100M.vue';
import Report100MDetail from '@/components/admin/ReportDetail.vue';
import ReportNatPat from '@/components/admin/ReportNatPat.vue';

import AdminSupportDetailsView from '@/components/admin/AdminSupportDetailsView.vue';
import SupportRequest from '@/components/admin/support/SupportRequest';
import SupportRequestSearch from '@/components/admin/support/SupportRequestSearch';

import ReportsTest from '@/components/admin/ReportsTest.vue';

Vue.component('data-collection-stats', AdminDataCollectionStats);
Vue.component('data-collection-view', AdminDataCollectionView);
Vue.component('office-details-view', AdminOfficeDetailsView);
Vue.component('office-tree-view', OfficeTreeView);
Vue.component('reports', Reports);
Vue.component('report-main', ReportMain);
Vue.component('report-detail', ReportDetail);
Vue.component('report-100m', Report100M);
Vue.component('report-100mdetail', Report100MDetail);
Vue.component('report-natpat', ReportNatPat);
Vue.component('admin-support-details-view', AdminSupportDetailsView);

Vue.component('support-request', SupportRequest);
Vue.component('support-request-search', SupportRequestSearch);

Vue.component('reports-test', ReportsTest);
